module.exports = __webpack_public_path__ + "static/media/user.8c234f2e.svg";